import React, {useState, useEffect, useRef} from 'react';
import { useLocation } from 'react-router-dom';
import "../../../css/header.scss"
import Cookies from 'js-cookie';
import { capitalizeWords } from '../../Helper';

import betaBlackLogo from '../../../images/betaBlackLogo.png';
import { useHistory } from 'react-router-dom';
import mobileMenu from '../../../images/mobileDashboard.png';
import searchBar from '../../../images/searchBar.png';
import LoginBottomSheet from '../Mobile/LoginBottomSheet';
import AddBusinessBottomSheet from '../Mobile/AddBusinessBottomSheet';
import HeaderMenu from './HeaderMenu';

function Header() {
    const history = useHistory();
    const showLoginContent = true;
    const [showHeaderMenu, setshowHeaderMenu] = useState(false);
    const [isAccountBottomSheetOpen, setIsAccountBottomSheetOpen] = useState(false);
    const [openAddBusiness, setOpenAddBusiness] = useState(false);
   
    const location = useLocation();
    useEffect(() => {
        if (location.pathname.length > 1) {
            var subtitle = location.pathname.replaceAll('/', ' | ');
            subtitle = subtitle.replaceAll('-', ' ');
            subtitle = capitalizeWords(subtitle);
            document.title = `RS11 ${subtitle}`;
        } else {
            document.title = 'RS11 | Home';
        }
        
        // Updating Meta Tag
        // const metaTags = [
        //     { property: 'og:title', content: `RS11 ${subtitle}` },
        //     { property: 'og:image', content: betaBlackLogo },
        // ];
    
        // metaTags.forEach((metaTag) => {
        // const existingTag = document.querySelector(`meta[property="${metaTag.property}"]`);
        // if (existingTag) {
        //     existingTag.setAttribute('content', metaTag.content);
        // } else {
        //     const newTag = document.createElement('meta');
        //     newTag.setAttribute('property', metaTag.property);
        //     newTag.setAttribute('content', metaTag.content);
        //     document.head.appendChild(newTag);
        // }
        // });
    }, [location]);

    let userId = Cookies.get('rs11_user_id') ?? 0;

    const closeHeaderMenu = (action) => {
        window.dataLayer.push({'event': 'menu_close'})
        if (action) {
            setshowHeaderMenu(false);
            setOpenAddBusiness(true);
        }
        else {
            setshowHeaderMenu(false);
        }
    }

    const handleAccountBottomSheetOpen = () => {
        setIsAccountBottomSheetOpen(true)
    }

    const handleAccountBottomSheetClose = (action) => {
        (action) && window.location.reload();
        setIsAccountBottomSheetOpen(false)
    }

    const handleSearch = () => {
        window.dataLayer.push({'event': 'header_search_icon'});
        history.push('/');
    }

    const handleShowMenu = () => {
        window.dataLayer.push({'event': 'menu_open'})
        setshowHeaderMenu(true);
    }


    const handleSignIn = () => {
        let accessToken = Cookies.get('access_token') ?? null;
        if (accessToken != null) {
            history.push(location.pathname);
            return
        }
        window.dataLayer.push({'event': 'header_sign_in'})
        setIsAccountBottomSheetOpen(true);
        setshowHeaderMenu(false);
    }

    const handleAddBusinessSheetOpen = () => {
        setOpenAddBusiness(true);
    }

    const handleAddBusinessSheetClose = () => {
        setOpenAddBusiness(false);
    }

    const handleHome = () => {
        history.push('/');
    }


    return(
        <div className='header-container'>
            {/* <div className='header-mobile'> */}
                <div className={"mobile-header"}>
                    <img className='menu-icon' src={mobileMenu} onClick={handleShowMenu} />
                    {/* `home_rs11_logo` class name is using in GA events. */}
                    <img className="header_rs11_logo" src={betaBlackLogo} onClick={() => handleHome()} alt={"rs11-logo"}/>
                    {
                        ((Cookies.get('access_token') ?? null) == null) ? (
                        <div>
                            <img className='search-bar add-space' src={searchBar} onClick={() => handleSearch()} />
                            <button className='login-button' onClick={() => handleSignIn()}>SIGN IN</button>
                        </div>
                        ) : (
                        <img className='search-bar' src={searchBar} onClick={() => handleSearch()} />)
                    }
                </div>
            {/* </div> */}
            {
                (openAddBusiness) && 
                    <AddBusinessBottomSheet 
                        isBottomSheetOpen={openAddBusiness}
                        onBottomSheetOpen={handleAddBusinessSheetOpen}
                        onBottomSheetClose={handleAddBusinessSheetClose} 
                    />
            }
            {
                (isAccountBottomSheetOpen) && 
                    <LoginBottomSheet 
                        isBottomSheetOpen={isAccountBottomSheetOpen}
                        onBottomSheetOpen={handleAccountBottomSheetOpen}
                        onBottomSheetClose={handleAccountBottomSheetClose}
                        showLoginContent={showLoginContent}
                    />
            }
            {
                (showHeaderMenu) &&
                <HeaderMenu 
                    showHeaderMenu={showHeaderMenu}
                    closeHeaderMenu={closeHeaderMenu}
                />
            }
        </div>
    )
}

export default Header;

